import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import {
  LocationOnOutlined,
  PersonOutline,
  LocalShippingOutlined,
  CalendarTodayOutlined,
  DescriptionOutlined,
} from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import GenericDetailSkeleton from "components/Shared/Skeleton/GenericDetailSkeleton";
import InformationTile from "components/Shared/InformationTile";
import Status from "components/Shared/Status";

import { useGetDeliveryDetailQuery } from "store/services/deliveryApi";

const DeliveryInfoScreen = ({ deliveryId }) => {
  const breadcrumbs = [{ title: "Delivery Info" }];

  const { data: deliveryDetail, isLoading: loadingDeliveryDetail, error } = useGetDeliveryDetailQuery(deliveryId);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingDeliveryDetail}>
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        {!loadingDeliveryDetail ? (
          <Box padding={3}>
            <Typography variant="h6">Delivery Details</Typography>
            <br />
            <Grid container spacing={4}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DescriptionOutlined color="primary" />}
                  title="Collection ID"
                  subtitle={deliveryDetail?.fulfillmentCompletionId}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <PersonOutline color="primary" />}
                  title="Driver"
                  subtitle={deliveryDetail?.driverId?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocalShippingOutlined color="primary" />}
                  title="Vehicle ID"
                  subtitle={deliveryDetail?.vehicle_id?.registration || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <LocationOnOutlined color="primary" />}
                  title="Entity"
                  subtitle={deliveryDetail?.entity?.name || "N/A"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <CalendarTodayOutlined color="primary" />}
                  title="Actual Delivery Time"
                  subtitle={new Date(deliveryDetail?.actualDeliveryTime).toLocaleString()}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DescriptionOutlined color="primary" />}
                  title="Delivery Notes"
                  subtitle={deliveryDetail?.deliveryNotes || "None"}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <DescriptionOutlined color="primary" />}
                  title="Document URL"
                  subtitle={
                    deliveryDetail?.documentUrl ? (
                      <a
                        href={deliveryDetail.documentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Document
                      </a>
                    ) : (
                      "Not Available"
                    )
                  }
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  icon={() => (
                    <Status
                      isActive={deliveryDetail?.status === "completed"}
                    />
                  )}
                  title="Status"
                  subtitle={deliveryDetail?.status || "Unknown"}
                />
              </Grid>
            </Grid>
          </Box>
        ) : (
          <GenericDetailSkeleton />
        )}
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryInfoScreen;
